import React, { Component } from "react";
import { connect } from "react-redux";
import instance from "../../../store/actions/instance";
import { clearUsedComponents } from "../../../store/actions";

import { cartToQuantity } from "../../../store/actions/b2b";

import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import PreviousOrderAgainCard from "./PreviousOrderAgainCard";

export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class index extends Component {
  state = {
    loading: false,
    pastOrders: [],
    search: "",
    searchLoading: false,
    tooltipOpen: false,
    alertOpen: false,
    activeItemIndex: 0,
  };

  handleFetchOrder = () => {
    const pastOrdersIds = this.props.pastOrders.slice(-3).sort((a, b) => b - a);
    const pastOrdersForReorderIds = this.props.partOrdersForReOrder
      .map((order) => order.id)
      .sort((a, b) => b - a);
    this.fetchPastOrders();
    if (
      this.props.partOrdersForReOrder.length == 0 ||
      this.props.pastOrders.length == 0
    ) {
      this.fetchPastOrders();
    }
  };
  componentDidMount = () => {
    this.handleFetchOrder();
  };
  componentDidUpdate = (prevProps) => {
    if (
      prevProps.partOrdersForReOrder.length !==
      this.props.partOrdersForReOrder.length
    ) {
      this.handleFetchOrder();
    }
  };

  async fetchPastOrders(search) {
    try {
      let used_components = this.props.used_components;
      const res = await instance.post(`/get_past_orders/`, {
        is_search: !!search,
        from_B2B: true,
        used_components: used_components,
        fetch_items: true,
        from_previous_orders: true,
        distributor: this.props.distributor.id,
      });
      this.props.fetchPastOrderForReorder(res.data, true);
    } catch (err) {
      console.error(err);
    }
  }

  EmptyCart = () => {
    const length = this.props.cart.length;
    for (let i = 0; i < length; i++) {
      this.props.remove_from_cart(0, this.props.cart[0]);
    }
    this.props.clearUsedComponents();
  };

  FindProduct = (pitem) => {
    try {
      let store_product = this.props.products.find(
        (product) => product.product.id === pitem.product_id
      );
      if (store_product) {
        let inventory = pitem.quantity;

        if (
          inventory >= store_product.minimum_order_quantity &&
          inventory <= store_product.maximum_order_quantity
        ) {
          return {
            store_product,
            quantity: inventory,
          };
        } else {
          inventory = Math.max(
            store_product.minimum_order_quantity,
            Math.min(inventory, store_product.maximum_order_quantity)
          );

          return {
            store_product,
            quantity: inventory,
          };
        }
      }
    } catch (err) {
      console.error(err);
      return false;
    }
    return false;
  };

  handleReOrder = async (p) => {
    let item = null;

    let allProductsFound = true;
    p.items.forEach((i) => {
      let { store_product, quantity } = this.FindProduct(i);
      if (!store_product) allProductsFound = false;
    });

    if (!allProductsFound) this.setState({ alertOpen: true });
    else {
      this.props.emptyCart();
      for (let i = 0; i < p.items.length; i++) {
        item = p.items[i];

        let { store_product, quantity } = this.FindProduct(item);
        if (store_product) {
          this.props.cartToQuantity(store_product.product.id, quantity, false);
        } else {
          continue;
        }
      }
      this.setState({ successAlertOpen: true });
      this.props.handleChange(p.payment_method);

    }
  };

  render() {
    const { language } = this.props;
    return (
      <div
        style={{
          paddingTop: 20,
        }}
      >
        <Snackbar
          open={this.state.alertOpen}
          autoHideDuration={3000}
          onClose={() => this.setState({ alertOpen: false })}
          classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
        >
          <Alert
            onClose={() => this.setState({ alertOpen: false })}
            severity="error"
          >
            {language === "english"
              ? "Order cant be placed because all products are not available"
              : "لا يمكن إعادة الطلب لأن جميع المنتجات لم تعد متوفره"}
          </Alert>
        </Snackbar>

        <Snackbar
          open={this.state.successAlertOpen}
          autoHideDuration={3000}
          onClose={() => this.setState({ successAlertOpen: false })}
          classes={{ anchorOriginBottomCenter: "snackbar-bottom-70" }}
        >
          <Alert
            onClose={() => this.setState({ successAlertOpen: false })}
            severity="success"
          >
            {language === "english"
              ? "Items added successfully"
              : "تمت إضافة المنتجات بنجاح"}
          </Alert>
        </Snackbar>

        {this.props.partOrdersForReOrder?.filter(
          (order) => !order.has_service && order.items.length > 0
        ).length > 0 && (
          <div>
            <h4
              style={{
                textAlign: language === "english" ? "left" : "right",
                marginLeft: language === "english" ? 15 : 0,
                marginRight: language === "english" ? 0 : 15,
                paddingTop: 17,
                fontWeight: 700,
                color: "#000000",
                fontSize: 16,
                fontFamily: "Quicksand",
              }}
            >
              {language === "english" ? "Order again" : "اعادة الطلب"}
            </h4>
            <div
              className={"hide-scrollbar"}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0 15px",
                marginBottom: 19,
                overflowX: "scroll",
                overflowY: "hidden",
                whiteSpace: "nowrap",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                flexDirection: language === "arabic" ? "row-reverse" : "row",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: language === "arabic" ? "row-reverse" : "row",
                }}
              >
                {this.props.partOrdersForReOrder
                  .filter(
                    (order) => !order.has_service && order.items.length > 0
                  )
                  .map((order) => (
                    <PreviousOrderAgainCard
                      order={order}
                      handleReorder={() => this.handleReOrder(order)}
                      themeColor={this.props.themeColor}
                    />
                  ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
    pastOrders: state.PastOrders.pastOrders,
    themeColor: state.store.store.settings.dark,
    language: state.store.language,
    cart: state.b2b.cartToQuantity,
    settings: state.store.store.settings,

    used_components: state.store.used_components,
    partOrdersForReOrder: state.PastOrders.partOrdersForReOrder,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    cartToQuantity: (id, value) => dispatch(cartToQuantity(id, value)),
    emptyCart: () => dispatch({ type: "EMPTY_CART" }),
    clearUsedComponents: () => dispatch(clearUsedComponents()),
    fetchPastOrderForReorder: (data) =>
      dispatch({ type: "FETCH_TO_PAST_ORDERS_FOR_REORDER_B2B", payload: data }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(index);
